import t from "react";
import { Text as o } from "../../../Text/Text.js";
import { VisuallyHidden as l } from "../../../VisuallyHidden/VisuallyHidden.js";
const r = 999,
  a = _ref => {
    let {
      children: e
    } = _ref;
    if (e == 0 || !e) return null;
    const n = "An\xFAncio favoritado por ".concat(e > r ? "mais de ".concat(r) : e, " pessoas");
    return t.createElement(t.Fragment, null, t.createElement(o.Caption, {
      color: "--color-neutral-110",
      "aria-hidden": !0
    }, e > r ? "+".concat(r) : e), t.createElement(l, null, n));
  };
export { a as FavoritesCount, r as MAX_FAVORITES_COUNT };